import {getCookie} from "../../sources/js/functions/getCookie";
import {controlRangeInput} from "../../sources/js/functions/form-control";

(function(){
    let modals = document.querySelectorAll('.modal');
    let overlay = document.getElementById('overlay');
    let body = document.getElementsByTagName('body')[0];
    let buttons = document.querySelectorAll('.btn_modal');
    let closeBtn = document.querySelectorAll('.modal__close');
    let dateCookie = new Date(new Date().getTime() + 2592000000);

    if (modals && closeBtn && buttons) {

        let modalDisable = function (current_modal) {
            overlay.classList.remove('active');
            current_modal.classList.remove('modal_active');
            body.classList.remove('no-scroll');
        }


        let modalEnable = (type_modal) => {
            let current_modal = document.getElementById(type_modal);

            overlay.classList.add('active');
            current_modal.classList.add('modal_active');
            body.classList.add('no-scroll');
        };


        closeBtn.forEach((btn) => {
            btn.addEventListener('click', function(){
                let current_modal = this.closest('.modal');

                modalDisable(current_modal)
            });
        });


        buttons.forEach((button) => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                let type_modal = this.getAttribute('data-modal');

                modalEnable(type_modal);
            });
        });


        modals.forEach((modal) => {
            modal.addEventListener('click', function (e) {
                e.target === this ? modalDisable(this) : false;
            });
        });


        /*=== Modal Form (Landing) ===*/

        const offer_block = document.getElementById('offer');
        const advantages_block = document.getElementById('advantages');
        const selectOffers_block = document.getElementById('selectOffers');
        const banner_block_btn = document.querySelector('#banner .btn');
        const modalForm = document.getElementById('modalForm');


        if(offer_block && advantages_block && selectOffers_block && modalForm && banner_block_btn) {

            let switchBlocks = () => {
                offer_block.style.display = 'block';
                advantages_block.style.display = 'block';
                selectOffers_block.style.display = 'none';
                banner_block_btn.setAttribute('href', '#' + offer_block.id);
            }

            let initPage = () => {
                let cookie = getCookie('subscribed');
                if(cookie) switchBlocks();
            }; initPage();


            document.addEventListener('wpcf7mailsent', function (e) {
                const price = document.getElementById('inputSumSelect');
                const input_range = document.getElementById('inputRangeSum');
                const input = document.getElementById('inputSum');
                const site_name = window.location.hostname;

                switchBlocks();
                modalDisable(modalForm)
                document.cookie = "subscribed=true; secure; samesite=strict; domain="+site_name+"; path=/; expires=" + dateCookie.toUTCString();

                if(input_range && input) {
                    input_range.value = price.value.replace(/\s/g, '');
                    controlRangeInput(input_range, input);
                }

            }, false);
        }
    }

})();
